import { flattenGraphSequence } from './flattenGraphSequence.js';
import { deleteStepFromGraph } from './deleteStepFromGraph.js';
import { cloneWorkflowGraph } from './cloneWorkflowGraph.js';

export const removeWorkflowStepsByIds = (workflow, ids, keepChildren = false) => {
  const steps = [...(workflow?.steps || [])];
  let graph = cloneWorkflowGraph(workflow?.graph);
  const deletedScheduleStepIds = [];

  const hasFolders = steps?.some((n) => n.appSlug === 'folder');

  // Get orphan steps using sequence before anything gets deleted
  const sequenceIds = flattenGraphSequence(graph, steps, null, hasFolders)?.map((n) => n.id);
  const orphanGraphSteps = Object.keys(graph).filter((n) => !sequenceIds.includes(n));

  for (let i = 0; i < ids.length; ++i) {
    const step = steps?.find((n) => n.id === ids[i]);
    if (step?.appSlug === 'schedule') {
      deletedScheduleStepIds.push(ids[i]);
    }
    graph = deleteStepFromGraph(graph, ids[i], { keepChildren });
  }

  // Delete orphan steps from graph. I decided to do it here instead of pushing into ids to avoid cases where orphans might have exits
  for (let i = 0; i < orphanGraphSteps.length; ++i) {
    delete graph[orphanGraphSteps[i]];
  }

  // Delete orphan steps from workflow
  const orphanWorkflowSteps = steps
    ?.filter((n) => {
      return !['input', 'trigger'].includes(n.type) && !graph[n.id];
    })
    .map((n) => n.id);

  const deletedStepIds = [...new Set([...orphanWorkflowSteps, ...ids])];

  const filteredSteps = workflow?.steps?.filter((step) => !deletedStepIds.includes(step.id)) || [];

  return { deletedStepIds, deletedScheduleStepIds, steps: filteredSteps, graph };
};
